import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IProduto } from "app/types/produto/IProduto";
import * as R from 'ramda'
import { atualizarItensAction } from 'app/redux/orcamentoSlice'
import * as gridItensActions from 'app/redux/gridItensSlice'


import globalMU from "globalMU";
import { popularPropriedadesNovoItem } from "./popularPropriedadesNovoItem";

import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import { IOrcamento } from "app/types/IOrcamento";
import { preencherDadosTratamentoMadeira } from "./preencherDadosTratamentoMadeira";
import { EntitesProdutoAgregado } from "app/components/agregados/Agregados";
import { EntitesSimilares } from "app/components/similares/Similares";
import { ProdutosSugeridos } from "app/components/sugerir-produto-agregado/SugerirProdutoAgregado";

export type AdicionarItensOutput = {
    status: "SUCESSO" | "ERRO"
    /**
     * 491123 — true quando o servidor adicionou itens ao orçamento MAS devolveu uma mensagem junto
     * (ressalva sobre o que foi gravado, comum em tinta: base + corantes, com aviso sobre um deles).
     * O status continua "SUCESSO": a mensagem já foi exibida por globalMU.tratarRetorno e quem
     * chamou deve seguir o fluxo de sucesso — limpar a cesta e confirmar a inclusão.
     */
    possuiAviso: boolean
}

declare var window: any

export async function adicionarItens(identificadorOrcamento: string, produtos: IProduto[] | EntitesProdutoAgregado[] | EntitesSimilares[] | ProdutosSugeridos[], voltarParaPesquisa: boolean = false): Promise<AdicionarItensOutput> {

    // const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = await microuniversoApi.Parametro.obter("ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL")

    try {
        globalMU.blockUI()
        const orcamentoLegado = window.orcamentoController.model

        // 491123 — baseline para decidir, depois da chamada, se o orçamento REALMENTE recebeu item
        // (ver a classificação erro × aviso abaixo). Precisa ser lido antes do POST.
        const quantidadeItensAntes = (store.getState().orcamento?.ItensOrcamento ?? []).length

        // const tipoOrcamento = orcamentoLegado.get("TipoOrcamento");

        // const numeroOrcamento = orcamentoLegado.get("Numero");

        

        // const produtosASeremEnviados = produtos.map(p => ({
        //     ...p,
        //     Ambiente: globalMU.isNotNullOrEmpty(ambienteOrcamento) ? ambienteOrcamento : undefined
        // }))

        // const identificadoresItensExistentes = (store.getState().orcamento.ItensOrcamento ?? []).map(i => i.Identificador)
        const orcamentoAtualizado = await microuniversoApi.Orcamento.adicionarItens(identificadorOrcamento, produtos)
        // const identificadoresNovosItens = R.difference(
        //     (orcamentoAtualizado.ItensOrcamento ?? []).map(i => i.Identificador),
        //     identificadoresItensExistentes
        // )

        // const informacoesOrcamento = {
        //     TipoOrcamento: tipoOrcamento,
        //     Numero: numeroOrcamento
        // }
        // const itensParaAtualizar = (orcamentoAtualizado.ItensOrcamento ?? []).map(
        //     i => R.includes(i.Identificador, identificadoresNovosItens) ?
        //         popularPropriedadesNovoItem({
        //             item: i, 
        //             corPorAmbiente: store.getState().corPorAmbiente, 
        //             informacoesOrcamento,
        //             valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL})
        //         : i
        // )
        // store.dispatch(atualizarItensAction({itens: itensParaAtualizar, acao: "ANEXAR",corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))

        //const temErro = (orcamentoAtualizado["HasErrors"] != undefined) && orcamentoAtualizado["HasErrors"] == true // 466807
        //const temAviso = (orcamentoAtualizado["ErrorLevel"] != undefined && orcamentoAtualizado["ErrorLevel"] != "warn") // 466807

        //if (!temErro && temAviso) { // 466807
        let temErro = false
        let temAviso = false
        let falhaAoAtualizarTotais = false
        let itensTotaisOrcamento: IOrcamento = null
        try {
            itensTotaisOrcamento = await microuniversoApi.Orcamento.obterItensTotaisOrcamento(identificadorOrcamento)// 466807
            window.orcamentoController.model.atualizar(itensTotaisOrcamento)// 466807
            orcamentoLegado.atualizar(itensTotaisOrcamento, true, true)// 466807
        } catch (e) {
            falhaAoAtualizarTotais = true
            console.error("Erro ao atualizar o orçamento", e)
        }

        // 491123 — o servidor tem DOIS desfechos COM mensagem, e o que os separa NÃO é o nível nem o
        // tipo da mensagem, e sim o orçamento ter recebido item ou não:
        //
        //   a) não adicionou  -> a mensagem é o motivo da recusa. Fluxo de falha: manter a cesta
        //                        intacta e o modal aberto para o usuário corrigir.
        //   b) adicionou + avisou -> a mensagem é uma ressalva sobre o que foi gravado (típico em
        //                        TINTA, que explode em base + corantes: o servidor grava os
        //                        componentes válidos e avisa sobre um deles). Fluxo de SUCESSO:
        //                        limpar a cesta e confirmar ao usuário.
        //
        // Contar itens é o único critério confiável aqui. Tentar deduzir pelo nível da mensagem não
        // funciona: `Error` está presente nos dois casos (globalMU.tratarRetorno o ANEXA ao orçamento
        // quando há DomainData real, e FABRICA um objeto sintético quando não há), e o caso (b) chega
        // a vir com ErrorLevel "Error" — é uma ressalva sobre um componente, não a recusa do produto.
        //
        // A contagem "depois" usa o GET de itens/totais acima como fonte principal: ele é lido do
        // servidor DEPOIS do insert, então reflete o que de fato foi gravado, independente do que o
        // payload do POST trouxe no caminho de mensagem. O retorno do POST entra como segunda fonte
        // (Math.max) para o caso de o GET vir sem itens.
        const quantidadeItensDepois = Math.max(
            (itensTotaisOrcamento?.ItensOrcamento ?? []).length,
            ((orcamentoAtualizado as IOrcamento)?.ItensOrcamento ?? []).length
        )
        const inseriuAlgumItem = quantidadeItensDepois > quantidadeItensAntes

        // 491123 — "entrou item no orçamento" MANDA sobre qualquer sinal de erro. Este teste vem
        // PRIMEIRO de propósito: antes ele era o último ramo, então um retorno nulo do POST (o
        // globalMU.tratarRetorno devolve null para ErrorType que não seja DomainLayerException) ou
        // uma falha ao reler os totais marcavam ERRO e a cesta ficava suja, mesmo com os produtos já
        // gravados. É o caso do AdicionarVarios da Fênix (ItensPedidoVenda.prg): o CATCH do laço
        // acumula a mensagem do produto recusado em LogUsuario e SEGUE adicionando os demais —
        // sucesso parcial com mensagem é o comportamento normal, não falha.
        if (inseriuAlgumItem) {
            temErro = false
            temAviso = orcamentoAtualizado == null
                || falhaAoAtualizarTotais
                || ('Error' in orcamentoAtualizado && orcamentoAtualizado.Error != null)
        } else if (orcamentoAtualizado == null || falhaAoAtualizarTotais) {
            temErro = true
        } else if ('Error' in orcamentoAtualizado && orcamentoAtualizado.Error != null) { // && 469431
            temErro = true // && 469431
        }

        // orcamentoAtualizado pode ser null justamente no caminho de mensagem — atualizar o legado
        // com null quebraria aqui, e os dados corretos já vieram do obterItensTotaisOrcamento acima.
        if (!temErro && orcamentoAtualizado != null) {
        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado as IOrcamento))
        }
        store.dispatch(gridItensActions.atualizarFlagAction())

        //preencherDadosTratamentoMadeira()
        
        const statusRetornar = temErro ? "ERRO" : "SUCESSO"
        /*
        return {
            status: "Error" in orcamentoAtualizado ? "ERRO" : "SUCESSO"
        }
       */
        return { status: statusRetornar, possuiAviso: temAviso }
    } 
    catch (e) {
        throw e
    }
    finally {
        globalMU.unblockUI()
    }
}
